import { useBlocksConfig, useSyncer } from "@pathwright/blocks-engine"
import View from "@pathwright/ui/src/components/ui/View"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useEffect, useState } from "react"
import ContentPublishCard from "../editor/ContentPublishCard"
import ContentPublishConfirmation from "../editor/ContentPublishConfirmation"
import ContentSourceLink from "../editor/ContentSourceLink"
import useResponseWarning from "../editor/useResponseWarning"

// Authoring entry point in the published document's toolbar; no editor state is needed.
const CohortCustomizationAction = () => {
  const { tc } = useTranslate()
  const { cohortCustomization } = useBlocksConfig()
  const {
    blocksContext,
    customizationBusy,
    setCustomizationsEnabled,
    checkCustomizationResponses
  } = useSyncer()
  const [open, setOpen] = useState(false)
  const [confirmingResponses, setConfirmingResponses] = useState(false)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    if (!open) setConfirmingResponses(false)
  }, [open])
  const customization = blocksContext?.customization
  const enabled = !!customization?.enabled
  const permitted = enabled
    ? customization?.capabilities.canDisable
    : customization?.capabilities.canEnable
  const canEditSource = !enabled && !!cohortCustomization?.sourceStepUrl
  const { checking, hasResponses } = useResponseWarning(
    checkCustomizationResponses,
    open && !!permitted
  )
  if (!cohortCustomization || (!permitted && !canEditSource)) return null

  const confirm = async () => {
    if (checking) return
    setError(null)
    if (!enabled && hasResponses && !confirmingResponses) {
      setConfirmingResponses(true)
      return
    }
    try {
      await setCustomizationsEnabled?.(!enabled)
      setOpen(false)
    } catch (error) {
      setError(error instanceof Error ? error.message : String(error))
    }
  }

  return (
    <View.Primary
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "flex-end",
        width: "100%",
        maxWidth: "1200px",
        padding: "10px"
      }}
    >
      <ContentPublishCard
        label={
          permitted
            ? enabled
              ? tc("Revert to source version")
              : tc("Customize")
            : tc("Edit in Source Path")
        }
        icon={enabled ? "recur" : "group"}
        busy={!!customizationBusy}
        error={error}
        open={open}
        onOpenChange={setOpen}
        footer={canEditSource && !confirmingResponses && <ContentSourceLink />}
      >
        {permitted && (
          <ContentPublishConfirmation
            action={enabled ? "revert" : "customize"}
            cohortName={cohortCustomization.cohortName}
            showResponseWarning={
              enabled ? !checking && hasResponses : confirmingResponses
            }
            busy={!!customizationBusy || checking}
            onConfirm={() => void confirm()}
            onCancel={() =>
              confirmingResponses
                ? setConfirmingResponses(false)
                : setOpen(false)
            }
          />
        )}
      </ContentPublishCard>
    </View.Primary>
  )
}

export default CohortCustomizationAction
